
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias/[category]",
      function () {
        return require("private-next-pages/noticias/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias/[category]"])
      });
    }
  